import { Trans } from '@lingui/react/macro';
import { DocumentRequirement } from 'components/Signup/TradingHistory/DocumentRequirement/DocumentRequirement';
import { TOfferDataRequirement } from 'lendingApi/lapiOverrides.types';
import sharedStyles from '../DocumentRequirements.module.css';

type TProps = {
  isOptional: boolean;
  isSubmitted: boolean;
  status?: TOfferDataRequirement['actions'][number]['status'];
};
export const BwaSusa = ({ isOptional, isSubmitted, status }: TProps) => {
  return (
    <DocumentRequirement
      title={
        <>
          <Trans>Current BWA and SuSa</Trans>
          <span className={sharedStyles.condition}>
            (<Trans>not older than 4 months</Trans>)
          </span>
        </>
      }
      documentType="management and balance accounts"
      isOptional={isOptional}
      isSubmitted={isSubmitted}
      status={status}
    >
      <ul>
        <li>
          <Trans>
            As an alternative to BWA we also accept{' '}
            <strong>Jahresabschluss, GuV</strong> or <strong>EÜR</strong>
          </Trans>
        </li>
        <li>
          <Trans>
            As an alternative to SuSa we accept <strong>Jahresabschluss</strong>{' '}
            and <strong>Bilanz</strong>
          </Trans>
        </li>
        <li>
          <Trans>
            BWA & SuSa can be exported directly from your accounting software or
            requested from your tax advisor
          </Trans>
        </li>
        <li>
          <Trans>
            <strong>Tips</strong> for getting the SuSa upload right the first
            time can be found{' '}
            <a
              href="https://support.iwoca.de/de/articles/12062178-susa-summen-und-saldenliste-praktische-tipps"
              target="_blank"
              rel="noreferrer"
            >
              here
            </a>
          </Trans>
        </li>
      </ul>
    </DocumentRequirement>
  );
};
